import { render, staticRenderFns } from "./stat-bar.vue?vue&type=template&id=b16e40dc&scoped=true&"
import script from "./stat-bar.vue?vue&type=script&lang=js&"
export * from "./stat-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16e40dc",
  null
  
)

export default component.exports